import script from "./add-edit.vue?vue&type=script&lang=ts&setup=true"
export * from "./add-edit.vue?vue&type=script&lang=ts&setup=true"

import "./add-edit.vue?vue&type=style&index=0&id=1ebae96c&scoped=true&lang=css"

import exportComponent from "/home/jenkins/agent/workspace/miyo-prod/ftrc-prd/src/project/fotile-riskctl/code/frontend/mgr/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1ebae96c"]])

export default __exports__